module.exports = __webpack_public_path__ + "img/clock.7dc388a4.svg";